<template>
    <div id="enrollment-blocked-lease-renew-widget"
         class="enrollment-blocked-lease-renew-widget ob-card"
         style="display: flex; flex-direction: column; gap: 10px;
         width: 100%; padding: 1.5em 2em; background-color: white;
         border: 2px solid #8746a8; border-radius: 10px;"
    >
        <div style="display: flex; flex-direction: row; justify-content: space-between">
            <i class="fa fa-info-circle" style="color: #473368; background-color: #dfcfff; padding: 5px 10px; border-radius: 50px;">
                <span style="font-family: 'Ubuntu', Arial, sans-serif;">
                    <b>&nbsp;&nbsp;Enrollment Information</b>
                </span>
            </i>
            <i class="fa fa-times" style="cursor: pointer;" @click="dismiss"></i>
        </div>
        <span>
            <b>Good news! You'll be automatically enrolled in the program when your lease renews.</b>
            <br />
            No further action is required at this time.
        </span>
    </div>
</template>

<script>
export default {
    methods: {
        dismiss() {
            let widget = document.getElementById("enrollment-blocked-lease-renew-widget");
            if (widget) {
                widget.style.display = "none";
            }
        }
    }
}
</script>
